import React, { useState, useEffect, useCallback } from 'react';
import Spline from '@splinetool/react-spline';
import fragileImage from './fragile.png';
import barcodeImage from './barcode.png';

function App() {
  const [glassSize, setGlassSize] = useState({ width: 80, height: 160 });
  const [isMobile, setIsMobile] = useState(false);
  const [recipientName, setRecipientName] = useState('YOU');


  const handleResize = useCallback(() => {
    setIsMobile(window.innerWidth <= 768); // Adjust this breakpoint as needed
    
    const scrollY = window.scrollY;
    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercentage = Math.min(scrollY / maxScroll, 1) * 4;
    const newWidth = Math.min(80 + (window.innerWidth - 80) * scrollPercentage, (window.innerWidth - 70));
    const newHeight = Math.min(160 + (window.innerHeight - 160) * scrollPercentage, (window.innerHeight - 80));

    setGlassSize({ width: newWidth, height: newHeight });
  }, []);

  useEffect(() => {
    handleResize(); // Initial check

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleResize);

    // Extract recipient name from URL path and convert to uppercase
    const pathSegments = window.location.pathname.split('/');
    const lastSegment = pathSegments[pathSegments.length - 1];
    const formattedName = lastSegment
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
      .toUpperCase(); // Convert the entire name to uppercase
    setRecipientName(formattedName);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleResize);
    };
  }, [handleResize]);

  const scrollY = window.scrollY;
  const maxScroll = document.documentElement.scrollHeight - window.innerHeight;

  const infoContainerWidth = isMobile ? glassSize.width - 80 : glassSize.width / 2 - 80;

  return (
    <div className="top">
      <div className="stamp">
        <div className="glassContainer" style={{ width: `${glassSize.width}px`, height: `${glassSize.height}px` }}>
          <div className="glass">
            <Spline scene="https://prod.spline.design/2aikj0aR7A1lc0gC/scene.splinecode" />
          </div>
          <div className="infoContainer" style={{ width: `${infoContainerWidth}px`, height: `${glassSize.height/2 - 80}px`, opacity: scrollY * 2 / maxScroll }}>
            <div className="info">
              <div className="infoHeader">BYE&nbsp;&nbsp;PARTY</div>
              <div className="infoText">
                <div className="infoTextRow">
                  <div className="infoTextItem">BLAH</div>
                  <div className="infoTextItem">BLAH</div>
                  <a className="infoTextItem" style={{opacity: 1, textDecoration: 'underline'}} href="https://calendar.google.com/calendar/render?action=TEMPLATE&text=farewell+party+%E2%9B%B4%EF%B8%8F&dates=20240827T030000Z/20240827T060000Z&location=945+Cowper+St%2C+Palo+Alto%2C+CA" target="_blank">
                    08.26
                  </a>
                </div>
                <div className="infoTextRow">
                  <a target="_blank" href="https://www.google.com/maps/place/945+Cowper+St" className="infoTextItem" style={{opacity: 1, textDecoration: 'underline'}}>HERE</a>
                  <div className="infoTextItem">BLAH</div>
                  <div className="infoTextItem">BLAH</div>
                </div>
                <div className="infoTextRow">
                  <div className="infoTextItem">BLAH</div>
                  <div className="infoTextItem">BLAH</div>
                  <div className="infoTextItem">BLAH</div>
                </div>
                <div className="infoTextRow">
                  <div className="infoTextItem">BLAH</div>
                  <div className="infoTextItem" style={{opacity: 1}}>08PM</div>
                  <div className="infoTextItem">BLAH</div>
                </div>
                <div className="infoTextRow">
                  <div className="infoTextItem">BLAH</div>
                  <div className="infoTextItem">BLAH</div>
                  <a href="sms:+13144018708&body=see%20you%20soon%20😎" className="infoTextItem" style={{opacity: 1, textDecoration: 'underline'}}>RSVP</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="glassPlaceholder" style={{width: '80px', height: '160px'}}></div>
        <div className="stampLeft">
          <div className="stampText">
            <img src={fragileImage} className="fragile" alt="Fragile" />
            <div>HANDLE WITH CARE</div>
            <div>AND SCROLL DOWN NOW</div>
          </div>
          <div className="stampPics">
            <div className="stampPicsTop">
              <div className="stampPicsTopItem"></div>
              <div className="stampPicsTopItem"></div>
              <div className="stampPicsTopItem"></div>
            </div>
            <div className="stampPicsBottom">
              <div className="stampPicsBottomItem"></div>
              <div className="stampPicsBottomItem"></div>
              <div className="stampPicsBottomItem"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="to">
        <div className="toName">TO {recipientName}</div>
        <img src={barcodeImage} className="barcode" alt="barcode" />
      </div>
    </div>
  );
}

export default App;